import * as React from "react";
import { ProxyFields } from "./ProxyFields";

import { IRow, TableColum } from "../interfaces";
import { IDispatcher } from "../../../helpers/Dispatcher";

import { getCell } from "./helpers";
import { cn, flattenKeys, getEntries, getKeys, getValues } from "../../../helpers/Utils";
import { getColumnsWithoutLastElement } from "./helpers/getRowsWithoutLastElement";
import { getNumberCell } from "./helpers/getCell";

interface TableBodyProps {
	api: unknown;
	schema: any;
	dispatcher: IDispatcher;
	disabled?: boolean;
	rows: IRow;
	errors: Record<string, Record<string, string>>;
	columns: Record<string | number, TableColum>;
	fieldsRef: Record<string | number, unknown & object & { groups?: Array<string> }>;
	setFieldsRef: any;
	dependenceLength: number;
	lastElementName?: string;
	editRow: (key: string | number) => (event: React.MouseEvent<HTMLButtonElement>) => void;
	deleteRow: (key: string | number) => (event: React.MouseEvent<HTMLButtonElement>) => void;
	getLastRowForSum: any;
}

export const TableBody = ({
	api,
	schema,
	dispatcher,
	disabled,
	columns,
	rows,
	errors,
	fieldsRef,
	setFieldsRef,
	dependenceLength,
	lastElementName,
	editRow,
	deleteRow,
	getLastRowForSum,
}: TableBodyProps) => {
	let arrayForSort;

	const lastRowForSum: { [key: string]: unknown } = getLastRowForSum([...getValues(rows), ...getValues(fieldsRef)]);

	if (getValues(rows)[0]) {
		arrayForSort = getValues(rows)[0] && flattenKeys(getValues(rows)[0]);
		delete arrayForSort[arrayForSort.indexOf(lastElementName)];
		delete arrayForSort[arrayForSort.indexOf("isEdit")];
		arrayForSort.push(lastElementName);
		arrayForSort.push("isEdit");
	}
	return (
		<tbody>
			{getColumnsWithoutLastElement(rows, lastElementName)?.map(
				([keyRow, { key, isEdit, groups, ...rowValue }], index) => (
					<tr key={keyRow} id={`${keyRow}`}>
						{!!key && <td style={{ width: "50px" }}>{index + 1}</td>}
						{getEntries(rowValue)?.map(([keyCol, valueCol]) => (
							<td
								key={`${keyRow}_${keyCol}`}
								className={cn({
									edit: isEdit,
								})}
							>
								{/* eslint-disable-next-line no-nested-ternary */}
								{isEdit ? (
									<ProxyFields
										api={api}
										dispatcher={dispatcher}
										disabled={disabled}
										keyCol={keyCol}
										keyRow={keyRow}
										columns={columns}
										column={columns[keyCol]}
										error={errors?.[keyRow]?.[keyCol]}
										inputRef={fieldsRef[keyRow] as Record<string, object>}
										setInputRef={setFieldsRef(keyRow, null)}
										fieldsRef={fieldsRef}
										tableSchema={schema}
									/>
								) : (
									getCell(columns[keyCol], valueCol)
								)}
							</td>
						))}
						{/* TODO: DRY!!! DRY!!! sorry */}
						{!!dependenceLength && !!groups?.length && (
							// eslint-disable-next-line react/jsx-no-useless-fragment
							<>
								{groups?.map((item, idx) => {
									const { key: _key, ...otherItems } = item;
									return (
										<td key={_key}>
											<div style={{ minWidth: "450px", display: "flex", justifyContent: "space-between" }}>
												{getEntries(otherItems).map(([keyCol, valueCol], valueIdx, array) => (
													<div
														key={keyCol?.toString()}
														style={{
															flexShrink: 0,
															textAlign: "center",
															width: `calc((100% / ${array.length}) - 8px)`,
														}}
													>
														{/* eslint-disable-next-line no-nested-ternary */}
														{isEdit ? (
															<ProxyFields
																api={api}
																dispatcher={dispatcher}
																disabled={disabled}
																keyCol={keyCol as string}
																keyRow={keyRow}
																columns={columns?.groups}
																column={columns?.groups?.[keyCol as string]}
																error={errors?.[keyRow]?.groups?.[idx]?.[keyCol]}
																inputRef={fieldsRef?.[keyRow]?.groups?.[idx] as any}
																setInputRef={setFieldsRef(keyRow, idx)}
																fieldsRef={fieldsRef}
																tableSchema={schema}
															/>
														) : (
															getCell(columns.groups?.[keyCol], valueCol)
														)}
													</div>
												))}
											</div>
										</td>
									);
								})}
							</>
						)}

						{!!lastElementName && (
							<td style={{ textAlign: "center" }}>
								{getCell(columns[lastElementName], rows[keyRow][lastElementName])}
							</td>
						)}
						<td className="td-buttons sticky">
							{!disabled && (
								<>
									<button
										type="button"
										className="btn btn-success btn-sm"
										onClick={editRow(keyRow)}
										disabled={!!isEdit}
									>
										<span className="glyphicon glyphicon-pencil" />
									</button>
									{
										!schema?.columns?.find(elem => elem.valueFromField) && (
											<button type="button" className="btn btn-danger btn-sm" onClick={deleteRow(keyRow)}>
												<span className="glyphicon glyphicon-trash" />
											</button>
										)
									}
								</>
							)}
						</td>
					</tr>
				)
			)}

			{!!lastRowForSum && !!getKeys(rows)?.length && (
				<tr key="keySum" id="keySum">
					<td>Итого</td>
					{getEntries(lastRowForSum)
						?.sort((a: unknown, b: unknown) => arrayForSort.indexOf(a[0]) - arrayForSort.indexOf(b[0]))
						.map(([keyCol, valueCol]) => (
							<td
								key={`keySum_${keyCol}`}
								style={{
									textAlign: "center",
								}}
								id={`${keyCol}`}
							>
								{getNumberCell(valueCol)}
							</td>
						))}
				</tr>
			)}
		</tbody>
	);
};
